// eslint-disable-next-line import/no-cycle
import { DEFAULT_LANGUAGE } from 'Constants/Global'
import { getLocaleMessages } from '../locale'

export const CHANGE_LOCALE = 'CHANGE_LOCALE'

export const changeLocale = ({ locale }) => {
	return {
		type: CHANGE_LOCALE,
		payload: { locale, messages: getLocaleMessages(locale) },
	}
}

const initialState = {
	locale: DEFAULT_LANGUAGE,
	messages: getLocaleMessages(DEFAULT_LANGUAGE),
}

export default function reducer(state = initialState, action) {
	switch (action.type) {
		case CHANGE_LOCALE:
			return { ...state, ...action.payload }
		default:
			return state
	}
}
